import { lazy } from "react";

const VoucherHistoryPage = lazy(() => import("./main"));
export { VoucherHistoryPage };
